import styled from "@emotion/styled";
import { Box } from "@mui/material";

const CoBrowsingNavBar = styled(Box)(() => ({
  backgroundColor: "white",
  padding: "10px 20px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
}));

export default CoBrowsingNavBar;
